export const IN_PROGRESS = 'inProgress';
export const SUCCEEDED = 'succeeded';
export const FAILED = 'failed';
